import { Component as OopsIcon } from 'icons/icon-ui--noresults.svg';
import styles from './MenuPage.module.scss';

type Props = {
  resetFilters: () => void;
}

const ZeroResultsPlaceholder = ({ resetFilters }: Props) => (
  <div className={styles.zero_results_container}>
    <OopsIcon width={78} height={78} />
    <h2>Oops! We couldn&apos;t find a match for your search.</h2>
    <h6>Try removing some filters</h6>
    <button type="button" className={styles.view_all_meals_btn} onClick={resetFilters}>
      View All
      Meals
    </button>
  </div>
);

export default ZeroResultsPlaceholder;
